<template>
	<div class="uk-relative">

	<form method="post" 
		@submit.prevent="submitForm"
		class="uk-form-stacked"
		id="delete-account-form"
		accept-charset="UTF-8"
		autocomplete="off"
	>
	
		<input type="hidden" :name="csrfName" :value="csrfToken">

		<div class="uk-field">
		
			<div class="uk-alert uk-alert-primary uk-margin-top uk-margin-bottom">
				Type het volgende woord in het veld hieronder over om je account te verwijderen: 
				<strong>{{ confirmationString }}</strong> 
			</div>

			<input 	
				type="text" 
				name="confirmationField" 
				id="confirmationField" 
				class="uk-input" 
				required
			>	
		
		</div>

		<div style="clear:both"></div>

		<button 
			class="uk-button uk-button-primary uk-align-right uk-margin-top uk-width-1-1 uk-width-auto@s" type="submit">verwijderen
		</button>	

		<div style="clear:both"></div>

		<div class="overlay" v-show="overlay">
			 <div class="uk-position-center">
					 <div class="uk-text-center">
						 <span v-show="loading"><loading-indicator></loading-indicator></span>
						 <span v-show="error" class="material-symbols-outlined"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg></span>
						 <span v-show="success" class="material-symbols-outlined"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg></span>
					 </div>
					 <p class="uk-text-center" v-html="message"></p>
			 </div>
		</div>

	</form>

	</div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	components: { LoadingIndicator },
	props: {
		confirmationString: {
			type: String,
			required: true,
		},
		redirect: {
			type: String,
			required: true,
		},
	},
	mounted() {
	},
	data() {
		return {
			overlay: false,
			error: null,
			success: false,
			loading: false,
			message: null,
		};
	},
	computed: {
		csrfName () {
				return window.csrfTokenName
		},
		csrfToken () {
				return window.csrfTokenValue
		},
	},	
	methods: {
		submitForm(e) {

			var component = this;

			// Data
			var data = {};
			
			// Form data
			var formData = new FormData(e.target);
			
			// Append CSRF
			formData.append(data[window.csrfTokenName], window.csrfTokenValue);
					
			// Toggle overly and indicator
			component.overlay = true;
			component.loading = true;

			// Request		
			axios({
				method: 'post',
				url: '/actions/porter/delete-account/delete', 
				//responseType: 'json',		
				data: formData,
				headers: {
					//'Content-Type' : 'application/x-www-form-urlencoded',
					//'Accept' : 'application/json'
				}
			})
			.then(function (response) {
								
				component.loading = false;
				
				var message = null;		
				var responseData = (error.response && error.response.data ) ?error.response.data : {};
				var error = responseData.error ? responseData.error : null;
				var errors = responseData.errors ? responseData.errors : null;
								
				if(error) {
					message = error;
				} else if(errors) {
					for (const item of Object.entries(errors)) {			
						if(typeof item[1][0] != "undefined") {					
							message += item[1][0] + '<br>';
						}
					}					
				}
			
				// Error
				if(error || errors) {
							
					// Update UI		
					component.loading = false;
					component.error = true;
					component.message = message;
					
					setTimeout(function() {
						component.resetMessage();
					}, 5000);
				
				// Success
				} else {
					
					component.success = true;
					component.message = "Account verwijderd.";
	
					setTimeout(function() {
						component.resetMessage();
					}, 2000);
						
				}
			})
			.catch(function (error) {
			
				var message = null;		
				var responseData = (error.response && error.response.data ) ?error.response.data : {};
				var error = responseData.error ? responseData.error : null;
				var errors = responseData.errors ? responseData.errors : null;

				console.log(responseData)

				if(error) {
					message = error;
				} else if(errors) {
					for (const item of Object.entries(errors)) {			
						if(typeof item[1][0] != "undefined") {					
							message += item[1][0] + '<br>';
						}
					}					
				}

				component.loading = false;
				component.error = true;
				component.message = (message) ? message : "Onbekende fout, probeer het opnieuw.";
				
				//component.setRecaptchaToken();
				
				setTimeout(function() {		
					component.resetMessage();
				}, 4000);	
			});

		},
		resetMessage: function() {
			
			var component = this;
			
			component.message = null;
			component.error = false;
			component.overlay = false;
			component.loading = false;		
		}
	},
};
</script>


<style>
.overlay {
	position: absolute; top: 0; height: 100%; width: 100%; z-index: 999; background-color: rgba(255, 255, 255, 0.9); 
}
</style>
